import React from 'react';

export const DiceIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            version="1.1"
            viewBox="0 0 5.821 5.821"
        >
            <g>
                <path
                    fill="#fcfcfc"
                    fillOpacity="1"
                    stroke="none"
                    strokeDasharray="none"
                    strokeMiterlimit="4"
                    strokeOpacity="1"
                    strokeWidth="1.6"
                    d="M6.17.563a1.996 1.996 0 00-1.592.998l-4 6.927a1.996 1.996 0 00.733 2.733l6.927 4a2 2 0 00.762.254V11c0-.192.022-.376.057-.557.02-.11.055-.214.088-.32.017-.057.031-.115.052-.17a2.96 2.96 0 01.19-.404c.006-.012.012-.024.02-.035.08-.14.17-.272.27-.397l.005-.004a2 2 0 01-.176-.088 2 2 0 01-.733-2.732 2 2 0 012.69-.758 2 2 0 01.002 0 2 2 0 01.04.026A2 2 0 0112.376 8h2.342l.254-.44a1.996 1.996 0 00-.733-2.732l-6.927-4A1.997 1.997 0 006.17.563zM4.969 6.755a2 2 0 01.119 0A2 2 0 016 7a2 2 0 01.043.025 2 2 0 01.73 2.73 2 2 0 01-2.73.733 2 2 0 01-.732-2.732 2 2 0 011.658-1z"
                    transform="scale(.26458)"
                ></path>
                <text
                    xmlSpace="preserve"
                    style={{ lineHeight: '1.25' }}
                    x="7.367"
                    y="0.374"
                    strokeWidth="0.265"
                    fontFamily="sans-serif"
                    fontSize="1.411"
                    letterSpacing="0"
                    wordSpacing="0"
                ></text>
                <path
                    fill="#fcfcfc"
                    fillOpacity="1"
                    stroke="none"
                    strokeDasharray="none"
                    strokeMiterlimit="4"
                    strokeOpacity="1"
                    strokeWidth="1.6"
                    d="M12 9c-1.108 0-2 .892-2 2v8c0 1.108.892 2 2 2h8c1.108 0 2-.892 2-2v-8c0-1.108-.892-2-2-2h-8zm.95 1a2 2 0 01.001 0A2 2 0 0113 10a2 2 0 012 2 2 2 0 01-2 2 2 2 0 01-2-2 2 2 0 011.95-2zm3 3a2 2 0 01.001 0A2 2 0 0116 13a2 2 0 012 2 2 2 0 01-2 2 2 2 0 01-2-2 2 2 0 011.95-2zm3.001 3A2 2 0 0119 16a2 2 0 012 2 2 2 0 01-2 2 2 2 0 01-2-2 2 2 0 011.951-2z"
                    transform="scale(.26458)"
                ></path>
            </g>
        </svg>
    );
};
